<template>
  <div>
    <p class="lead mb-5">
      {{ $tt('about_page.founded') }}
    </p>
    <p v-html="$tt('about_page.experience', { domain: $domain })" />
  </div>
</template>

<style scoped>
.lead {
  font-size: 24px;
}

@media (max-width: 850px) {
  .lead {
    font-size: 20px;
  }
}
</style>